/**
******************************************************************
* Written by: Dana Moshe
******************************************************************
*/
export enum SortOrder {
	// The enum element must be in the same order in the server!!!!!!!!!!!!!
	asc, desc
}


export interface ILookupSort {

	/**
	* Column name to sort by him.
	*/
	field:string;

	dir:SortOrder;
}
